import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { FETCH_UNITS, FETCH_UNITS_FAIL, FETCH_UNITS_SUCCESS } from '../redux/unitsReducer'

function* FetchUnitsFlow(): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, { endpoint: '/tutors/units', method: 'GET', params: {} })
    yield put(FETCH_UNITS_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_UNITS_FAIL())
    console.log(error)
  }
}

export default function* FetchUnitsSaga(): Generator<any, void, any> {
  yield takeLatest([FETCH_UNITS], FetchUnitsFlow)
}
